import { css } from '@emotion/react'
import {
  GemColors,
  Spacing,
  Transition,
  Typography,
  wideGamutColor,
  ZIndex,
} from '@opallabs/gem'

export const container = css({
  display: 'grid',
  gridTemplateRows: '0fr',
  position: 'sticky',
  insetBlockStart: 0,
  inlineSize: '100%',
  zIndex: ZIndex.Element.Level1,

  '&[aria-hidden="true"] > div': {
    paddingBlock: 0,
  },
  '&[aria-hidden="false"]': {
    gridTemplateRows: '1fr',
  },

  '&[data-status="connecting"], &[data-status="disconnected"]': {
    backgroundColor: wideGamutColor('#FFF1E6'),
    color: wideGamutColor('#903509'),
  },
  '&[data-status="connected"]': {
    backgroundColor: wideGamutColor(GemColors.G100),
    color: wideGamutColor(GemColors.G600),
  },

  ...Transition(['gridTemplateRows', 'backgroundColor', 'color'], {
    duration: 300,
  }),
})

export const content = css({
  ...Typography.T500,

  overflow: 'hidden',
  paddingBlock: Spacing.S,
  color: 'inherit',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: Spacing.S,

  ...Transition(['paddingBlock'], { duration: 300 }),
})
